import { UpdateResidencyJurisdictionRequest } from '../../../../web-api-client';
import { ResidencyJurisdiction } from '../../models';

export const mapResidencyJurisdictionToUpdateRequest = (
  residencyJurisdiction: ResidencyJurisdiction
): UpdateResidencyJurisdictionRequest => {
  return new UpdateResidencyJurisdictionRequest({
    residencyJurisdictionId: residencyJurisdiction.residencyJurisdictionId,
    countryId: residencyJurisdiction.country!.countryId!,
    isActive: residencyJurisdiction.isActive,
  });
};
